<div class="check-group" *ngIf="options && options.length"
	[style.padding-right]="colsPaddingRight"
	[style.column-count]="numColumns">
	<div
	*ngFor="let option of options; let i = index;"
	class="check-row"
	[hidden]="showMoreLimit > 0 && i >= showMoreLimit && !showMore"
	[class.selected]="selectedOption?.value === option.value"
	title="{{option?.label}}">
		<label [class.disabled]="disabledOptions && disabledOptions.indexOf(option.value) !== -1">
			<bb-check
				*ngIf="theme !== 'light-v2'"
				[(ngModel)]="checkedModels[option.value]"
				(ngModelChange)="checkChanged(option, $event, i)"
				[disabled]="disabledOptions && disabledOptions.indexOf(option.value) !== -1"
			></bb-check>
			<bb-check
			*ngIf="theme === 'light-v2'"
				[(ngModel)]="checkedModels[option.value]"
				(ngModelChange)="checkChanged(option, $event, i)"
				[disabled]="disabledOptions && disabledOptions.indexOf(option.value) !== -1"
				class="small"
				theme="dark-theme"
				color="#3693ef"
				falseColor="#ebebeb"
			></bb-check>
			<span class="label-text">{{ option?.label }}</span>
		</label>
	</div>
	<div *ngIf="showMoreLimit > 0 && options?.length > showMoreLimit" class="show-more" (click)="onShowMoreClick()">
		{{ (showMore ? 'SHOW_LESS' : 'SHOW_MORE') | translate }}
		{{ !showMore && moreCount ? '(' + moreCount + ' ' + ('SELECTED' | translate | lowercase) + ')' : '' }}
	</div>
</div>
